import { ApprovalFlow } from '@ulysses-inc/harami_api_client'
import Redux from 'redux'
import {
  addApprovalFlow as addApprovalFlowAction,
  deleteApprovalFlow as deleteApprovalFlowAction,
  getApprovalFlow as getApprovalFlowAction,
  getApprovalFlows as getApprovalFlowsAction,
  updateApprovalFlow as updateApprovalFlowAction,
} from './actions'

const getApprovalFlow = (dispatch: Redux.Dispatch, approvalFlowId: string) => {
  dispatch(getApprovalFlowAction(approvalFlowId))
}

const getApprovalFlows = (dispatch: Redux.Dispatch) => {
  dispatch(getApprovalFlowsAction())
}

const addApprovalFlow = (
  dispatch: Redux.Dispatch,
  approvalFlow: ApprovalFlow,
) => {
  dispatch(addApprovalFlowAction(approvalFlow))
}

const updateApprovalFlow = (
  dispatch: Redux.Dispatch,
  approvalFlowId: string,
  approvalFlow: ApprovalFlow,
) => {
  dispatch(updateApprovalFlowAction(approvalFlowId, approvalFlow))
}

const deleteApprovalFlow = (
  dispatch: Redux.Dispatch,
  approvalFlowId: string,
) => {
  dispatch(deleteApprovalFlowAction(approvalFlowId))
}

export default {
  getApprovalFlow,
  getApprovalFlows,
  addApprovalFlow,
  updateApprovalFlow,
  deleteApprovalFlow,
}
